/* eslint-disable n/no-callback-literal */
/* eslint-disable react/display-name */
import React, { useMemo, useState, useCallback, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { FormProps, ColumnType, Input, Icon, Tooltip, Select, Switch, DatePicker, TimePicker, InputNumber, Cascader, Radio, Checkbox, Message, TreeSelect, TableProps } from '@tinper/next-ui';
import MergeTable from '../../../common/MergeTable';
import Operations from "../../../common/CardAndDataTable/DataTableOperations";
import { v4 as uuidv4 } from 'uuid';
import { normalize, haveCommonItems, isFunc, getOperationItems } from './utils/Utils';
import FormContent from './components/FormContent';

// import { RefTreeWithInput } from "../../RefTree/src";
// import { RefMultipleTableWithInput } from "../../RefTable/src";
// import { RefTreeTableWithInput } from "../../RefTreeTable/src";
import './index.less'

type Key = React.Key;
type DefaultRecordType = Record<string, any>;
const prefix = `as`

const { RangePicker } = DatePicker;

interface RowOption {
    pos: string,
    posRowKey?: Key,
    rowData?: DefaultRecordType,
    callback?: (options: {data: DefaultRecordType[], addData: DefaultRecordType[], isEditKeys: Key[]}) => void
}

// editType需要扩展函数，支持联动以及获取其他单元格数据,支持fieldProps，支持renderFormItem（渲染编辑态表格自定义元素）,render自定义渲染只读时候的内容。function(record, index)
export interface EditColumnType extends ColumnType {
    editType?: Function | 'input' | 'select' | 'date' | 'time' | 'switch'| 'treeselect' |'textarea'| 'number'|'inputNumberGroup' | 'rangepicker' | 'cascader' | 'radiogroup' | 'checkboxgroup' | 'reftable' | 'reftree' | 'reftabletree'|'custom',
    formItemProps?:any[],
    render:Function, // 配置预览显示状态内容
    renderFormItem?: (form: any, record: DefaultRecordType, index: number, column: DefaultRecordType) => React.ReactNode, // 配置编辑态内容
    textToFormItemValue?:(text:any, record: DefaultRecordType, column: DefaultRecordType, index: number) =>any, // 文本转换成form单元格值
    editOptions?: any, // field配置项
    editAbled?: boolean | ((record: DefaultRecordType, index: number, column: DefaultRecordType) => boolean),
    onCellChange?: (record: DefaultRecordType, column: DefaultRecordType, value: string) => void,
    pattern?: string, // 正则校验
    validator?: (value: any, record: any, data: any, callback: any) => void // 自定义校验 ？ index
}

interface EditTableType extends TableProps {
    type:"inline" | "inlineForm" | "FormModal",
    autoEditedByClickRows?: false | 'click' | 'hover',
    validateTrigger?: 'onChange' | false // 验证时机
    columns: EditColumnType[],
    formProps?: FormProps,
    cancelText: string,
    saveText:string,
    editText:string,

}

const INNER_ROW_KEY = 'edit_table___key'; // 每条数据缓存原来的rowkey的属性

/**
 * @description: 基础编辑表格
 * @return {*}
 */

const EditTable: any = forwardRef(function EditTable (props: EditTableType, ref: any) {
  const editRef = useRef()
  const tableCellHeight = useRef();
  const editRowHeight = useRef();
  const hoverRecord = useRef();
  const {
    type: tableType,
    columns,
    data = [],
    rowKey = 'key',
    children,
    childrenColumnName = 'children',
    rowSelection = {},
    onRowClick,
    autoEditedByClickRows = 'hover', // 是否开启点击行启动编辑状态
    autoCheckedByClickRows = false,
    showRowNum,
    className,
    popMenu,
    onPopMenuClick,
    onRowHover,
    operationItems,
    operationTypeProps,
    operationType,
    operationClick,
    isBigData = false,
    isSingleFind = true,
    isSum = false,
    isDragColumn = true,
    isFilterColumn = true,
    isSort = true,
    isSingleFilter = true,
    // validateTrigger = 'onChange',
    rowClassName,
    onDropRow,
    fieldid,
    formProps,
    saveText,
    cancelText,
    editText
    // expandable
    // onPopMenu,
    // onPopMenuClick
  } = props;
  const { type = 'checkbox', onChange, selectedRowKeys, defaultSelectedRowKeys, ...otherRowSelection } = rowSelection || {}

  const isEditRef = useRef([])
  const editRowRef = useRef() // 缓存的编辑态的数据
  const selectedRowRef = useRef([]); // 缓存选中的数据的key
  const tableColumnsMap = useRef({}); // 列宽度
  const formDefaultValues = useRef({}) // 缓存表单默认值，以便于创建数据时，默认写入。

  // 数据操作
  //   1，数据改变
  //   2，keyStatus改变
  //   3，cellErrors改变
  // 只保存key key: rowKey => value : 状态类型
  const [keyStatus, setKeyStatus] = useState({}) // 所有的状态管理， 'add' | 'edit' | 'del' | 'cacheAdd'
  const [isEditKeys, setIsEditKeys] = useState<Key[]>([]); // 编辑态的行key
  const [innerData, setInnerData] = useState<DefaultRecordType[]>(data || []); // 内部的数据
  const [innerSelectedRowKeys, setInnerSelectedRowKeys] = useState<Key[]>([]);
  const [cellErrors, setCellErrors] = useState<any>({}) // 单元格的错误提示
  const [currentEdit, setCurrentEdit] = useState(null)
  const [foldStatus, setFold] = useState(false)

  const setFoldStatus = useCallback(() => {
    setFold(!foldStatus)
  }, [foldStatus])

  formDefaultValues.current = useMemo(() => {
    const defaultValues = {};
    columns?.forEach(item => {
      const { dataIndex, editOptions = {} } = item;
      const { defaultValue } = editOptions;
      if (typeof defaultValue !== 'undefined') {
        defaultValues[dataIndex] = defaultValue;
      }
    })
    return defaultValues;
  }, [columns])

  useEffect(() => {
    tableCellHeight.current = document.querySelector(".wui-table-body-cell")?.clientHeight;
    editRowHeight.current = tableCellHeight.current;
  }, [])

  const innerSetTreeKey = useCallback((data: any) => {
    return (data || []).reduce((newData: any, record: any, _index: any) => {
      const currentKeyValue = record[rowKey];
      const newItem = {
        ...record,
        [INNER_ROW_KEY]: currentKeyValue
      }
      if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
        newItem.children = innerSetTreeKey(record.children);
      }
      newData.push(newItem);
      return newData;
    }, []);
  }, [childrenColumnName, rowKey])

  const eidtData = useMemo(() => {
    const newData = innerSetTreeKey(data)
    return newData;
    // return data.reduce((newData, record, index) => {
    //     let currentKeyValue = record[rowKey];
    //     let newItem = {
    //         ...record,
    //         [INNER_ROW_KEY]: currentKeyValue,
    //     }
    //     if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
    //         newItem.children = getTreeShowData(record.children);
    //     }
    //     newData.push(newItem);
    //     return newData;
    // }, []);
  }, [data, rowKey])

  useMemo(() => {
    const propsSelectedRowKeys = selectedRowKeys || defaultSelectedRowKeys;
    if (propsSelectedRowKeys && Array.isArray(propsSelectedRowKeys)) {
      setInnerSelectedRowKeys(propsSelectedRowKeys);
      selectedRowRef.current = propsSelectedRowKeys;
    }
  }, [selectedRowKeys, defaultSelectedRowKeys])

  useMemo(() => {
    if (JSON.stringify(isEditKeys) !== JSON.stringify(isEditRef.current || [])) {
      setIsEditKeys(isEditRef.current)
    }
  }, [isEditKeys, isEditRef.current])

  useMemo(() => {
    if (JSON.stringify(eidtData) !== JSON.stringify(innerData)) {
      setInnerData(eidtData)
    }
  }, [eidtData])

  useMemo(() => {
    if (JSON.stringify(editRowRef.current) !== JSON.stringify(currentEdit)) {
      setCurrentEdit(editRowRef.current)
    }
  }, [editRowRef.current, currentEdit])

  const innerShowRowNum = useMemo(() => {
    if (typeof showRowNum === 'boolean' && showRowNum) {
      return {
        base: 1
      }
    } else if (typeof showRowNum === 'object') {
      return {
        ...showRowNum,
        base: 1
      }
    } else {
      return showRowNum
    }
  }, [showRowNum])

  // 处理rowKey(后续不支持函数传入)
  //  const getRowKey = useMemo(() => {
  //     if (typeof rowKey !== 'string') {
  //         throw new Error(`传入 rowKey 不符合格式, 请调整为 string 格式`);
  //     }
  //     return (record: DefaultRecordType) => (record[rowKey as string])
  // }, [rowKey])
  const getRowKey = useMemo(() => { // 以内部属性为标准
    if (typeof rowKey !== 'string') {
      throw new Error(`传入 rowKey 不符合格式, 请调整为 string 格式`);
    }
    return (record: DefaultRecordType) => (record[INNER_ROW_KEY])
  }, [rowKey])

  // 内部需要的多选单选的属性
  const mergeRowSelection = useMemo(() => {
    const onInnerChange = (selectedRowKeys: Key[], selectedRows: DefaultRecordType[]) => {
      if (selectedRowKeys === undefined || selectedRowKeys === null) {
        setInnerSelectedRowKeys(selectedRowKeys)
        selectedRowRef.current = selectedRowKeys;
      }
      onChange && onChange(selectedRowKeys, selectedRows)
    }
    return {
      type,
      selectedRowKeys: innerSelectedRowKeys,
      ...otherRowSelection,
      onChange: onInnerChange
    }
  }, [innerSelectedRowKeys, rowSelection, selectedRowKeys])

  /** ************列相关的处理 start******************/

  // cloumns处理
  const innerColumns = useMemo(() => {
    let _innerColumns = columns;
    if (columns === undefined && children && Array.isArray(children) && children.length > 0) {
      _innerColumns = normalize(children)
    }
    function renderColumns (_innerColumns) {
      return (_innerColumns || []).map((col) => {
        const { editAbled = true, dataIndex } = col;
        if (tableColumnsMap.current[dataIndex]) {
          col.width = tableColumnsMap.current[dataIndex].width;
        }
        const columnItem = editAbled
          ? {
            ...col,
            render: (text: any, record: DefaultRecordType, index: number) => {
              return renderCell(col, text, record, index, editAbled)
            }
          }
          : { ...col }
        if (columnItem.children && columnItem.children.length) {
          return {
            ...columnItem,
            children: renderColumns(columnItem.children)
          }
        }
        return columnItem;
      })
    }

    return renderColumns(_innerColumns || []);
  }, [columns, isEditKeys, getRowKey, cellErrors, innerData, children, currentEdit, tableColumnsMap.current])

  const renderCell = useCallback((col: EditColumnType, text: any, record: DefaultRecordType, index: number, editAbled: boolean | Function) => {
    const { editType, editOptions = {}, dataIndex, render, onCellChange, helpTip, editTip, renderFormItem, textToFormItemValue } = col;
    const currentKey = getRowKey(record);

    let view: any = null;
    if (typeof editAbled === 'function') {
      editAbled = editAbled(record, index, col)
    }
    const isEdit = (isEditRef.current || isEditKeys).includes(currentKey)

    const isAdd = keyStatus && keyStatus[currentKey] === "cacheAdd";

    // 如果不允许编辑，有render，直接渲染自定义内容
    if (render && !editAbled) {
      const textContent = render(text, record, index, { isEdit, isAdd, editAbled, column: col, allData: innerData });
      console.log(isAdd, textContent, keyStatus, currentKey, "isAdd")
      view = isAdd && typeof textContent === "undefined" ? "--" : textContent;
    } else {
      // 单元格编辑态
      if (isEdit) {
        // 行内编辑，处理单元格渲染表单内容
        if (editAbled && tableType === "inline") {
          if (!editRowRef.current || getRowKey(record) !== getRowKey(editRowRef.current)) {
            editRowRef.current = { ...record };
          }
          let showValue = editRowRef.current[dataIndex]
          if (textToFormItemValue && isFunc(textToFormItemValue)) {
            showValue = textToFormItemValue(record[dataIndex], record, col, index);
          }

          if (renderFormItem && isFunc(renderFormItem)) {
            const childrenDom = renderFormItem(null, record, index, col);
            return React.cloneElement(childrenDom, { ...editOptions, defaultValue: showValue, onChange: (value: any) => cellChange({ value, record, index, currentKey, col, onCellChange }) });
          }
          switch (editType) {
          case 'input': // 可自定义传入输入框的各种配置
            view = <Input {...editOptions} defaultValue={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case 'textarea': // 可自定义传入输入框的各种配置
            view = <Input type="textarea" {...editOptions} defaultValue={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case 'inputNumberGroup': // 可自定义传入输入框的各种配置
            view = <InputNumber.InputNumberGroup {...editOptions} defaultValue={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case 'number':
            view = <InputNumber {...editOptions} value={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case 'select':
            view = <Select {...editOptions} defaultValue={showValue} onChange={(value: any, option: any) => cellChange({ value, record, index, currentKey, option, col, onCellChange })}/>
            break;
          case 'switch':
            view = <Switch {...editOptions} defaultChecked={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case 'cascader':
            view = <Cascader {...editOptions} value={showValue} onChange={(value: any, cascaderOptions: any) => cellChange({ value, record, index, currentKey, editOptions, col, cascaderOptions, onCellChange })}/>
            break;
          case 'date':
            view = <DatePicker {...editOptions} value={showValue} onChange={(value: any, valueString: any) => cellChange({ value, record, index, currentKey, valueString, col, onCellChange })}/>
            break;
          case 'rangepicker':
            view = <RangePicker {...editOptions} value={showValue} onChange={(value: any, valueString: any, valueStringArr: any) => cellChange({ value, record, index, currentKey, valueString, valueStringArr, col, onCellChange })}/>
            break;
          case 'time':
            view = <TimePicker {...editOptions} value={showValue} onChange={(value: any, valueString: any) => cellChange({ value, record, index, currentKey, valueString, col, onCellChange })}/>
            break;
          case 'radiogroup':
            view = <Radio.Group {...editOptions} value={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case 'checkboxgroup':
            view = <Checkbox.Group {...editOptions} value={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case "treeselect":
            view = <TreeSelect {...editOptions} value={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
            break;
          case "custom":
            view = <Input {...editOptions} defaultValue={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>;
            if (renderFormItem && isFunc(renderFormItem)) {
              const childrenDom = renderFormItem(null, record, index, col);
              view = React.cloneElement(childrenDom, { ...editOptions, defaultValue: showValue, onChange: (value: any) => cellChange({ value, record, index, currentKey, col, onCellChange }) });
            }
            break;

          // case 'reftable':
          //   view = <RefMultipleTableWithInput {...editOptions} value={showValue} onChange={(value) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>;
          //   break;
          // case 'reftree':
          //   view = <RefTreeWithInput {...editOptions} value={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>;
          //   break;
          // case 'reftabletree':
          //   view = <RefTreeTableWithInput {...editOptions} value={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
          //   break;
          default:
            view = <Input {...editOptions} defaultValue={showValue} onChange={(value: any) => cellChange({ value, record, index, currentKey, col, onCellChange })}/>
          }
        } else {
          // 编辑态，不可编辑单元格内容的显示方式
          if (editType === 'switch') {
            view = <Switch {...editOptions} checked={text} disabled/>
          } else {
            // 针对新增行
            view = typeof text === "undefined" ? "--" : text;
          }
        }
      } else {
        // 行内查看态
        if (editType === 'switch') {
          view = <Switch {...editOptions} checked={text} disabled/>
        } else {
          console.log(isAdd && typeof text === "undefined", text, col, "2222")
          view = typeof text === "undefined" ? "--" : text;
        }
        if (render) {
          const textContent = render(text, record, index, { isEdit, isAdd, editAbled, column: col, allData: innerData });
          console.log(isAdd, textContent, keyStatus, currentKey, "isAdd")
          view = typeof textContent === "undefined" ? "--" : textContent;
        }
      }
    }
    const realkey = record[rowKey];
    const hasError = (cellErrors[realkey] || {})[dataIndex as Key];
    if (isEdit) { // 编辑态
      const overlayClassNameAttr = hasError ? { overlayClassName: 'eidt-cell-error-tip' } : {}
      view = <Tooltip inverse={hasError} {...overlayClassNameAttr} arrowPointAtCenter delay={200} overlay={hasError ? (cellErrors[realkey][dataIndex as Key] || {}) : editTip || null}>
        <div className={hasError ? 'eidt-cell-error' : ''}>
          {view}
        </div>
      </Tooltip>
    } else { // 查看态
      if (hasError) {
        view = <>
          <div className={`${prefix}-table-edit-cell-tip`}>
            <Tooltip arrowPointAtCenter delay={200} overlay={(cellErrors[realkey][dataIndex as Key] || {})}>
              <Icon type="uf-exc-c" style={{ color: '#f50' }}/>
            </Tooltip>
          </div>
          {view}
        </>
      } else {
        view = helpTip
          ? <Tooltip arrowPointAtCenter delay={200} overlay={helpTip}>
            {view}
          </Tooltip>
          : view;
      }
    }
    view = <div className={`${prefix}-edit-cell`} onScroll={(e) => { e.stopPropagation(); return false }}>
      {view}
    </div>
    return view
  }, [isEditKeys, cellErrors, getRowKey, innerColumns, innerData, currentEdit])

  /**
     * @description: 内置的单元格编辑change事件
     * @param {*} value 改变后的值
     * @param {*} dataIndex 对应的列
     * @param {*} record 改变值的当前行
     * @param {*} index 当前行的下标
     * @param {*} onCellChange 当前单元格改变后的事件
     * @return {*} tempRows：插入后的新的rows
     */
  const cellChange = useCallback((options: any) => {
    // const { value, record, option, valueString, valueStringArr, cascaderOptions, onCellChange, col } = options;
    const { value, record, onCellChange, col, valueStringArr, valueString } = options;
    // const { dataIndex, editType, editOptions, validateTrigger } = col;
    const { dataIndex, validateTrigger, editType } = col;
    const realValidateTrigger = validateTrigger // 验证时机
    let cellValue: null | string = value;
    // if (editType === 'select') {
    //   if (editOptions.mode === 'tags') {
    //     const { separator = '/' } = editOptions; // 默认分隔符
    //     cellValue = value.map((item: any) => {
    //       return option.find((opt: any) => opt.value === item)?.label || item
    //     }).join(separator);
    //   } else {
    //     cellValue = option && option.label
    //   }
    if (editType === 'date' || editType === 'time') {
      cellValue = valueString
    } else if (editType === 'rangepicker') {
      cellValue = valueStringArr
    // } else if (editType === 'cascader') {
    //   const { separator = '/' } = editOptions; // 默认分隔符
    //   cellValue = cascaderOptions.map((item: any) => item.label).join(separator)
    // } else if (editType === 'radiogroup') {
    //   const { options: radioOptions = [] } = editOptions;
    //   const realLabel = radioOptions.find((opt: any) => opt.value === value)?.label || ''
    //   cellValue = realLabel
    // } else if (editType === 'checkboxgroup') {
    //   const { options: checkOptions = [] } = editOptions;
    //   const list:string[] = [];
    //   (value || []).forEach((val: string) => {
    //     const current = checkOptions.find((opt: any) => opt.value === val)?.label || '';
    //     if (current) {
    //       list.push(current)
    //     }
    //   })
    //   cellValue = list.join(',')
    } else {
      cellValue = value
    }

    const target = { ...(editRowRef.current || {}) }
    target[dataIndex] = cellValue;
    editRowRef.current = target;
    setCurrentEdit(editRowRef.current)
    if (realValidateTrigger === 'onChange') { // 实时校验
      innerValidate({
        range: 'cell', // 校验范围
        value: cellValue,
        column: col,
        validateRecord: editRowRef.current
      })
    }

    onCellChange && onCellChange(record, col, value)
  }, [innerColumns, cellErrors, isEditKeys, currentEdit])

  /** ************列相关的处理 end******************/

  // 获取所有状态的key的集合方法
  const getKeyStatus = useCallback(() => {
    const innerAddKeys: string[] = []; // 新增keys集合
    const innerEditKeys: string[] = []; // 编辑过的keys集合
    const innerDelKeys: string[] = []; // 删除keys集合
    Object.keys(keyStatus || {}).forEach(key => {
      if (keyStatus[key] === 'add') {
        innerAddKeys.push(key)
      } else if (keyStatus[key] === 'edit') {
        innerEditKeys.push(key)
      } else if (keyStatus[key] === 'del') {
        innerDelKeys.push(key)
      }
    })
    return { innerAddKeys, innerEditKeys, innerDelKeys }
  }, [keyStatus])

  /** ************数据处理 start******************/

  // 树形数据遍历筛选掉已删除的数据
  const getTreeShowData = useCallback((data: DefaultRecordType[]) => {
    const { innerDelKeys = [] } = getKeyStatus();
    return data.reduce((filteredArray, record, index) => {
      const currentKey = getRowKey(record, index);
      if (!innerDelKeys.includes(currentKey)) {
        const newItem = { ...record };
        if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
          newItem.children = getTreeShowData(record.children);
        }
        filteredArray.push(newItem);
      }
      return filteredArray;
    }, []);
  }, [getRowKey, childrenColumnName, keyStatus, getKeyStatus])

  // 过滤已删除的数据
  const showData = useMemo(() => {
    const showRows = getTreeShowData(innerData);
    return showRows;
  }, [innerData, keyStatus, getKeyStatus])

  // 获取新增的数据
  const innerAddRows = useCallback(() => {
    const { innerAddKeys } = getKeyStatus();
    const innerAddData = getKeyData(innerAddKeys)
    return innerHandleData(innerAddData);
  }, [keyStatus])

  // 获取编辑过的数据
  const innerEditRows = useCallback(() => {
    const { innerEditKeys } = getKeyStatus();
    const innerAddData = getKeyData(innerEditKeys)
    return innerHandleData(innerAddData);
  }, [keyStatus])

  // 获取删除的数据
  const innerDelRows = useCallback(() => {
    const { innerDelKeys } = getKeyStatus();
    const innerAddData = getKeyData(innerDelKeys)
    return innerHandleData(innerAddData, false);
  }, [keyStatus])

  // 外部回调拿到的数据，需要去除内部添加的属性
  // data: 处理的数据
  // delete: 是否过滤已删除的数据
  // type: del => 删除内置的属性， add: 添加内置的属性
  const innerHandleData = useCallback((data: any, delate = true, type = 'del') => {
    const { innerDelKeys } = getKeyStatus();
    return (data || []).reduce((newData: any, record: any, _index: any) => {
      const currentKeyValue = record[rowKey];
      const newItem = { ...record }
      if (type === 'del') {
        delete newItem[INNER_ROW_KEY]
      } else {
        newItem[INNER_ROW_KEY] = newItem[INNER_ROW_KEY] || currentKeyValue;
      }
      if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
        newItem.children = innerHandleData(record.children, delate, type);
      }
      if (!delate || !innerDelKeys.includes(currentKeyValue)) {
        newData.push(newItem);
      }
      return newData;
    }, [])
  }, [innerData, childrenColumnName, rowKey, keyStatus])

  /** ************数据处理 end******************/

  /** ************内置方法 start******************/

  // 获取数据的所有key
  const getDataKeys = useCallback((data: any, list = []) => {
    return data.reduce((keys: any, record: any, index: any) => {
      const currentKey = getRowKey(record, index);
      keys.push(currentKey);
      if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
        getDataKeys(record[childrenColumnName], keys)
      }
      return keys;
    }, list)
  }, [childrenColumnName, getRowKey])

  // 树形数据遍历获取对应key的数据
  const getTreeKeyData = useCallback((data: DefaultRecordType[], keys: Key[]) => {
    return data.reduce((filteredArray, record, index) => {
      const currentKey = record[rowKey];
      if (keys.includes(currentKey)) {
        const newItem = { ...record };
        if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
          const filterData = getTreeKeyData(record.children, keys);
          filteredArray.push(...filterData);
        }
        filteredArray.push(newItem);
      } else {
        if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
          const filterData = getTreeKeyData(record.children, keys);
          filteredArray.push(...filterData);
        }
      }
      return filteredArray;
    }, [])
  }, [rowKey, childrenColumnName])

  // 根据key获取对应的数据
  const getKeyData = useCallback((keys: Key[]): DefaultRecordType[] => {
    const keyRows = getTreeKeyData(innerData, keys);
    return keyRows;
  }, [innerData, getRowKey])

  // 把树形数据平铺
  const dataTreeToList = useCallback((rows: any): DefaultRecordType[] => {
    const flatArray: any = [];
    function flatten (record: any) {
      flatArray.push(record);
      if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length > 0) {
        for (const child of record[childrenColumnName]) {
          flatten(child);
        }
      }
    }
    for (const rootNode of rows) {
      flatten(rootNode);
    }
    return flatArray;
  }, [childrenColumnName])

  /**
     * @description: 获取末级columns
     * @return {*}
     */
  const getLeafColumns = useCallback(() => {
    const leafColumns:ColumnType<DefaultRecordType>[] = [];
    innerColumns.forEach((column: any) => {
      if (!column.children || (column.children && Array.isArray(column.children) && column.children.length === 0)) {
        leafColumns.push(column);
      } else {
        leafColumns.push(...getLeafColumns(column.children));
      }
    });
    return leafColumns;
  }, [innerColumns])

  /** ************内置方法 end******************/

  /** ************新增 start******************/

  // 内置构建一行新的数据
  const addNewRow = useCallback((rowData?: DefaultRecordType): DefaultRecordType => {
    let newRow: DefaultRecordType = {}
    let newKey = uuidv4(); // 随机rowKey
    if (!rowData) {
      newRow[rowKey] = newKey
      newRow[INNER_ROW_KEY] = newKey
      // 构建新数据时候，默认值加入数据
      Object.assign(newRow, formDefaultValues.current);
    } else {
      const rowDataKey = rowData[0][rowKey] || newKey;
      newRow = {
        ...rowData[0],
        [rowKey]: rowDataKey,
        [INNER_ROW_KEY]: rowDataKey
      };
      newKey = rowDataKey;
    }
    return { newRow, newKey };
  }, [rowKey])

  /**
     * @description: 增加行
     * @param {*} options {pos: first/last/before/after, rowKey, rowData, callBack}
     * @param {*} pos first/last/before/after 插入方式
     * @param {*} posRowKey 当前行的key
     * @param {*} rowData 插入数据，没有则新增内置数据
     * @param {*} callback 插入行之后的回调
     * @return {*}
     */
  const innerAddRow = useCallback((options: RowOption) => {
    const { pos, posRowKey, rowData, callback } = options; // rowKey => posRowKey
    let newRows: DefaultRecordType[] = [];
    let newRowKeys: Key[] = []
    let newIsEditKeys: Key[] = [...isEditKeys]
    let rows = [...innerData];
    const innerKeyStatus = { ...keyStatus }
    if (Array.isArray(rowData) && rowData.length > 1) { // 处理批量数据,不设置编辑态
      // 校验是否和原来的数据有相同的key，有的话不允许添加
      const newKeys = getDataKeys(rowData);
      const result = haveCommonItems(newKeys, getDataKeys(innerData));
      if (result) {
        throw new Error('新增的数据和原数据有相同的key, 请修改');
      } else {
        // 新传入的数据需要内部增加内置属性处理
        newRows = innerHandleData(rowData, false, 'add');
        newRowKeys = newKeys;
        // 外部批量新增数据, 直接把所有的key设置为新增状态
        newKeys.forEach(key => {
          innerKeyStatus[key] = 'add';
        })
      }
    } else {
      const { newRow, newKey } = addNewRow(rowData)
      newRows = [newRow];
      newRowKeys = [newKey];
      // editRowRef.current = newRow;
      innerEditRowData({
        rowKey: newKey,
        edit: true,
        rowData: { ...newRow },
        callback: (options: any) => {
          const { data } = options;
          if (data) {
            rows = innerHandleData(data, false, 'add');
          }
        }
      })
      // 内置新增数据, 把新增的key设置为`缓存新增`状态（缓存新增状态是为了新增数据点击取消可以直接删除）
      newRowKeys.forEach(key => {
        innerKeyStatus[key] = 'cacheAdd'
      })
      // 设置编辑态，为了回调可以不用异步造成问题
      newIsEditKeys = [newKey]
    }
    if (pos === 'first') { // 首行追加
      rows = newRows.concat(rows);
    } else if (pos === 'last') { // 尾行追加
      rows = rows.concat(newRows);
    } else { // 指定位置插入,树形数据
      if (posRowKey) {
        rows = innerInsertRow(rows, pos, posRowKey, newRows)
      }
    }
    setKeyStatus(innerKeyStatus);
    setIsEditKeys(newIsEditKeys)
    setInnerData(rows);
    callback && callback({ data: innerHandleData(rows), addData: innerHandleData(newRows), isEditKeys: newIsEditKeys })
  }, [innerData, getKeyStatus, isEditKeys, getRowKey, keyStatus, columns])

  /**
     * @description: 插入行
     * @param {*} tempRows：插入后的新的rows
     * @param {*} data: 原本的数据
     * @param {*} type：插入位置 before/after
     * @param {*} rowKey：当前行的key
     * @param {*} newRows：要插入的行
     * @return {*} tempRows：插入后的新的rows
     */
  const innerInsertRow = useCallback((data: DefaultRecordType[], type: string, rowKey: Key, newRows: DefaultRecordType[]) => {
    return data.reduce((newData, record, index) => {
      const currentKey = getRowKey(record, index);
      const newRecord = { ...record };
      if (rowKey === currentKey) {
        if (type === 'after') {
          const tempRows = [newRecord].concat([...newRows])
          newData.push(...tempRows)
        } else if (type === 'before') {
          const tempRows = newRows.concat([newRecord])
          newData.push(...tempRows)
        } else if (type === 'child') {
          if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
            newRecord[childrenColumnName].unshift(...newRows)
          } else {
            newRecord[childrenColumnName] = newRows
          }
          newData.push(newRecord);
        }
      } else if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
        const upDateChildren = innerInsertRow(record[childrenColumnName], type, rowKey, newRows);
        newRecord[childrenColumnName] = upDateChildren;
        newData.push(newRecord)
      } else {
        newData.push(newRecord)
      }
      return newData;
    }, [])
  }, [childrenColumnName, getRowKey])

  /** ************新增 end******************/

  /** ************编辑/更新数据 start******************/

  // 保存编辑后的数据，替换数据
  const setNewData = useCallback((data: any, key: any, newData: any) => {
    const updateData = newData || editRowRef.current; // newData存在则说明外部覆盖更新，不存在则说明编辑更新缓存的数据
    // let realKey = editRowRef.current[rowKey];
    key = editRowRef.current[rowKey] !== editRowRef.current[INNER_ROW_KEY] ? editRowRef.current[INNER_ROW_KEY] : key;
    return data.reduce((mergeData: any, record: any, index: any) => {
      const currentKey = getRowKey(record, index);
      const newItem = (key === currentKey && updateData) ? { ...updateData } : { ...record };
      if (newItem[INNER_ROW_KEY] !== newItem[rowKey]) { // 更新内部属性的值，保持一致
        newItem[INNER_ROW_KEY] = newItem[rowKey]
      }
      if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
        newItem.children = setNewData(record.children, key, newData);
      }
      mergeData.push(newItem);
      return mergeData;
    }, [])
  }, [innerData, getRowKey, rowKey])

  // 更新数据
  // 如果更新了对应的rowKey.则需要更新keyStatus和验证信息中的rowKey
  // 保存对rowKey唯一性需要做强校验
  const innerUpDateData = useCallback((options: any) => {
    let { rowKey: innerRowKey, callback } = options;
    innerRowKey = innerRowKey || getRowKey(editRowRef.current || {})
    if (innerRowKey) {
      // 需要验证是否有相同的rowkey,有的话需要强行拦截保存，否则会渲染异常
      if (editRowRef.current && editRowRef.current[rowKey] !== editRowRef.current[INNER_ROW_KEY]) { // 说明更新了rowKey
        const restKeys = getDataKeys(innerData).filter((key: any) => key !== editRowRef.current[INNER_ROW_KEY])
        // let newKeys = getDataKeys(rowData);
        const result = haveCommonItems([innerRowKey], restKeys);
        if (result) {
          // throw new Error('编辑的数据和原数据有相同的key, 请修改');
          Message.create({ content: '编辑的数据和原数据有相同的rowKey, 请修改', color: 'danger' });
          return;
        }
      }
      // 1，验证
      innerValidate({
        range: 'row',
        validateRecord: editRowRef.current,
        callback: (newCellErrors: any) => { // 保存时候需要对这行的数据保存的key进行替换
          if (editRowRef.current[rowKey] !== getRowKey(editRowRef.current || {})) { // rowKey已编辑过
            if (newCellErrors[getRowKey(editRowRef.current)]) {
              newCellErrors[editRowRef.current[rowKey]] = newCellErrors[getRowKey(editRowRef.current)];
              delete newCellErrors[getRowKey(editRowRef.current)];
            }
          }
        }
      });
      // 3，更新key的状态，更新数据
      const innerKeyStatus = { ...keyStatus };
      if (innerKeyStatus[editRowRef.current[INNER_ROW_KEY]] && innerKeyStatus[editRowRef.current[INNER_ROW_KEY]] === 'cacheAdd') { // 暂存的新增更替为新增状态
        innerKeyStatus[innerRowKey] = 'add';
        if (editRowRef.current && editRowRef.current[rowKey] !== editRowRef.current[INNER_ROW_KEY]) { // 更新了rowKey
          delete innerKeyStatus[editRowRef.current[INNER_ROW_KEY]]
        }
      } else { // 非新增的数据替换为编辑状态
        if (innerKeyStatus[editRowRef.current[INNER_ROW_KEY]] === 'add') { // 新增数据
          if (editRowRef.current && editRowRef.current[rowKey] !== editRowRef.current[INNER_ROW_KEY]) { // 改变了本来就是新增数据的key值，直接替换key,不改变状态
            innerKeyStatus[editRowRef.current[rowKey]] = 'add';
            delete innerKeyStatus[editRowRef.current[INNER_ROW_KEY]];
          }
        } else {
          innerKeyStatus[innerRowKey] = 'edit'
          if (editRowRef.current && editRowRef.current[rowKey] !== editRowRef.current[INNER_ROW_KEY]) { // 更新了rowKey
            delete innerKeyStatus[editRowRef.current[INNER_ROW_KEY]]
          }
        }
      }

      // 4, 更新已选数据的key
      if (editRowRef.current && editRowRef.current[rowKey] !== editRowRef.current[INNER_ROW_KEY]) { // 更新了rowKey
        const _innerSelectedRowKeys = [...selectedRowRef.current] || [innerSelectedRowKeys];
        if (_innerSelectedRowKeys.includes(editRowRef.current[INNER_ROW_KEY])) {
          const selectIndex = _innerSelectedRowKeys.findIndex(item => item === editRowRef.current[INNER_ROW_KEY])
          _innerSelectedRowKeys.splice(selectIndex, 1, editRowRef.current[rowKey]);
          setInnerSelectedRowKeys(_innerSelectedRowKeys)
          selectedRowRef.current = _innerSelectedRowKeys;
        }
      }

      setKeyStatus(innerKeyStatus);
      const newInnerData = setNewData(innerData, innerRowKey)
      isEditRef.current = []
      editRowRef.current = {}; // 清空缓存的数据
      setIsEditKeys(isEditRef.current)
      setInnerData(newInnerData)
      callback && callback({ isEditKeys: [], data: innerHandleData(newInnerData), cellErrors })
    }
  }, [keyStatus, innerData, getRowKey, cellErrors, rowKey])

  // 编辑或保存某一行数据
  const innerEditRowData = useCallback((options: any) => {
    const { rowKey, edit, callback, newRecord } = options;
    if (edit) { // 进入编辑态
      // 可能新增，也可能原来存在,newRecord存在则为新增
      let newData = innerData;
      if (editRowRef.current) { // 原来存在编辑态的行需要先验证保存
        innerUpDateData({
          callback: (options: any) => {
            const { data } = options;
            if (data) {
              newData = data;
            }
          }
        }) // 先保存原来编辑态的数据
      }
      if (newRecord) { // 新增
        editRowRef.current = newRecord
      } else {
        editRowRef.current = getKeyData([rowKey])[0]
      }
      if (!(isEditRef.current || isEditKeys).includes(rowKey)) {
        isEditRef.current = [rowKey];
      }
      callback && callback({ isEditKeys: [rowKey], data: innerHandleData(newData) })
      setIsEditKeys(isEditRef.current)
    } else { // 进入查看态
      innerUpDateData({ rowKey, callback }) // 先保存原来编辑态的数据
    }
  }, [getRowKey, innerData, getKeyStatus])

  // 删除数据
  const innerDeltreeData = useCallback((newKeyStatus, data, delKeys, delChildren) => {
    return data.reduce((target, record, index) => {
      target.newData = target.newData || [];
      target.newKeyStatus = newKeyStatus || target.newKeyStatus || {};
      const currentKey = getRowKey(record, index);
      const newRecord = { ...record };
      let canAdd = true;
      if (delKeys.includes(currentKey) || delChildren) {
        if (isEditKeys.includes(currentKey)) { // 编辑态的直接去除编辑态
          setIsEditKeys([])
          isEditRef.current = null;
          editRowRef.current = null;
        }
        if (target.newKeyStatus[currentKey] && target.newKeyStatus[currentKey] === 'cacheAdd') { // 新增还未保存，编辑态
          delete target.newKeyStatus[currentKey]
          canAdd = false;
        } else {
          target.newKeyStatus[currentKey] = 'del'
        }
        if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
          const childrenTarget = innerDeltreeData(target.newKeyStatus, record[childrenColumnName], delKeys, true)
          newRecord[childrenColumnName] = childrenTarget.newData;
        }
        canAdd && target.newData.push(newRecord);
      } else {
        if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
          const childrenTarget = innerDeltreeData(target.newKeyStatus, record[childrenColumnName], delKeys, false);
          newRecord[childrenColumnName] = childrenTarget.newData;
        }
        canAdd && target.newData.push(newRecord);
      }
      // target.newData.push(newRecord);
      return target;
    }, {})
  }, [innerData, getRowKey, keyStatus, childrenColumnName, isEditKeys])

  // 删除数据
  const innerDelData = useCallback((options) => {
    const { rowKey, callback } = options;
    const delKeys = Array.isArray(rowKey) ? rowKey : [rowKey];
    const innerKeyStatus = { ...keyStatus }
    const { newData, newKeyStatus } = innerDeltreeData(innerKeyStatus, innerData, delKeys);
    innerClearRowError({ rowKey }) //  清除改行的错误信息
    setInnerData(newData);
    setKeyStatus(newKeyStatus);
    console.log('editRowRef.current', editRowRef.current)
    callback && callback()
  }, [innerData, keyStatus, isEditKeys])

  // 取消保存
  const innerCancel = useCallback((options) => {
    const { rowKey } = options;
    const currentKey = rowKey || getRowKey(editRowRef.current || {})
    const innerKeyStatus = { ...keyStatus }
    if (innerKeyStatus[currentKey] && innerKeyStatus[currentKey] === 'cacheAdd') { // 内置新增行并且未保存过,则清除缓存新增状态，并删除数据
      innerDelData({ rowKey: currentKey });
    } else {
      innerValidate({
        range: 'row',
        validateRecord: getKeyData([currentKey])[0]
      })
    }
    editRowRef.current = null;
    isEditRef.current = null;
    setIsEditKeys([]);
  }, [getRowKey, innerData, keyStatus])

  const innerOnDropRow = useCallback((data, record, dragTargetIndex, dropRecord, dropTargetIndex) => {
    setInnerData(data)
    onDropRow && onDropRow(data, record, dragTargetIndex, dropRecord, dropTargetIndex)
  }, [onDropRow])

  /** ************编辑/更新数据 end******************/

  /** ************更新单元格 start******************/

  const updateCellValue = useCallback((newKeyStatus, data, changeTarget: any, dataIndex: Key) => {
    const changeKeys = Object.keys(changeTarget);
    return data.reduce((target, record, index) => {
      target.newData = target.newData || [];
      target.newKeyStatus = newKeyStatus || target.newKeyStatus || {};
      const currentKey = getRowKey(record, index);
      const newRecord = { ...record };
      if (changeKeys.includes(currentKey)) {
        newRecord[dataIndex] = changeTarget[currentKey]
        if (target.newKeyStatus[currentKey] && target.newKeyStatus[currentKey] !== 'add' && target.newKeyStatus[currentKey] !== 'cacheAdd') {
          target.newKeyStatus[currentKey] = 'edit' // 标记为编辑过的
        }
      }
      if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
        const childrenTarget = updateCellValue(target.newKeyStatus, newRecord[childrenColumnName], changeTarget, dataIndex)
        newRecord[childrenColumnName] = childrenTarget.newData;
      }
      target.newData.push(newRecord);
      return target;
    }, {})
  }, [innerData, getRowKey, childrenColumnName])

  /**
     * 更新指定列下的单元格值
     * @param dataIndex 列数据索引名
     * @param cellValue 单元格更新后的值
     * @param fillType 更新填充方式：all-整列更新(默认),up-从指定行向上更新,down-从指定行向下更新, single-单独单元格
     * @param rowKey 当更新方式为 up|down 时，必须指定此参数值
     * @param callback 更新后的回调
     * @param fillNum 填充的行数
     */
  const innerSaveColumnData = useCallback((options) => {
    const { dataIndex, cellValue, fillType, rowKey: propsRowKey, callback, fillNum } = options;
    // 需要验证是否更新的事row,如果是，需要判断是否有重复的
    if (rowKey === dataIndex) { // 说明更新的是整列的rowKey,直接提示不允许更新
      Message.create({ content: `不允许更新${rowKey}所在的列数据`, color: 'danger' });
      return;
    }
    const dataList = dataTreeToList(innerData);
    const currentIndex = dataList.findIndex((record, index) => propsRowKey === getRowKey(record, index)); // 当前行
    let startIndex = 0;
    let endIndex = 0;
    if (fillType === 'up') {
      const num = typeof fillNum === 'number' ? fillNum : 0;
      endIndex = currentIndex;
      startIndex = currentIndex - num;
    } else if (fillType === 'down') {
      const num = typeof fillNum === 'number' ? fillNum : 0;
      startIndex = currentIndex;
      endIndex = currentIndex + num;
    } else if (fillType === 'single') {
      startIndex = currentIndex;
      endIndex = currentIndex + 1;
    } else {
      startIndex = 0;
      endIndex = dataList.length;
    }
    const changeTarget = {} // 存放更换的key-value键值对
    for (let i = startIndex; i < endIndex; i++) {
      const currentRecord = dataList[i];
      // dataList[i][dataIndex] = cellValue;
      const currentKey = getRowKey(currentRecord, i)
      changeTarget[currentKey] = cellValue; // 记录要更新的rowKey和value
    }
    const innerKeyStatus = { ...keyStatus }
    const data = [...innerData]
    const { newData, newKeyStatus } = updateCellValue(innerKeyStatus, data, changeTarget, dataIndex);
    setInnerData(newData);
    setKeyStatus(newKeyStatus)
    callback && callback()
  }, [innerData, keyStatus, rowKey])

  /**
     * 更新指定行键值对应的多个单元格的数据（即：更行数据）
     * @param list 返回整理的数据
     * @param rowData 列数据
     */
  const saveInnerMultiCellTreeData = useCallback((rowData, data, newCheckRecord, newKeyStatus, range) => {
    const setKey = (rowData || {})[INNER_ROW_KEY] && (rowData || {})[INNER_ROW_KEY] !== (rowData || {})[rowKey] ? (rowData || {})[INNER_ROW_KEY] : (rowData || {})[rowKey];
    return data.reduce((target, record, index) => {
      target.newData = target.newData || [];
      target.newKeyStatus = newKeyStatus || target.newKeyStatus || {};
      target.newCheckRecord = target.newCheckRecord || {};
      const currentKey = record[rowKey];
      let newRecord = { ...record }
      if (setKey === currentKey) {
        if (range === 'row') { // 更新整个行
          newRecord = rowData;
        } else { // 更新指定行的某些单元格
          Object.keys(rowData).forEach(key => {
            newRecord[key] = rowData[key]
          })
        }
        target.newCheckRecord = newRecord;
        target.newKeyStatus[currentKey] = 'edit';
      }
      if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
        const childrenTarget = saveInnerMultiCellTreeData(rowData, record[childrenColumnName], newCheckRecord, target.newKeyStatus, range);
        newRecord[childrenColumnName] = childrenTarget.newData;
      }
      target.newData.push(newRecord);
      return target
    }, {})
  }, [innerData, childrenColumnName, rowKey])

  /**
     * 更新指定行键值对应的多个单元格的数据（即：更行数据）更新完需要验证
     * @param rowData 列数据
     */
  const saveInnerMultiCellData = useCallback((options) => {
    const { rowData, callback, range = 'row' } = options;
    const innerKeyStatus = { ...keyStatus };

    const data = [...innerData];
    const checkRecord = {}
    const { newData, newCheckRecord, newKeyStatus } = saveInnerMultiCellTreeData(rowData, data, checkRecord, innerKeyStatus, range);

    innerValidate({
      range: 'row',
      validateRecord: newCheckRecord,
      callback: (newCellErrors) => {
        callback && callback(newData, newCellErrors)
      }
    });
    setInnerData(newData);
    setKeyStatus(newKeyStatus);
  }, [innerData, childrenColumnName, getRowKey])

  /** ************更新单元格 end********************/

  /** ************移动行 start*********************/

  /**
     * 将指定行进行移动
     * 参数options列表
     * @param rowKey string|array 需要移动的行键值，一般为勾选的行键值
     * @param pos number 移动的位置 负数表示上移，正数表示下移，例如：-1 为上移一行、1 为下移一行
     * @param clearSelected boolean 移动后是否清除勾选状态
     * @param callback 移动完成后的回调
     */
  const innerRowMoveTo = useCallback((options) => {
    const { rowKey, pos, clearSelected, callback } = options || {};
    const rowKeys = Array.isArray(rowKey) ? rowKey : [rowKey]
    const list = [...innerData]
    const data = moveTreeData(list, rowKeys, pos);
    setInnerData(data)
    if (clearSelected) {
      selectedRowRef.current = [];
      setInnerSelectedRowKeys([]);
    }
    callback && callback()
  }, [innerData])

  /**
     * @description: 树形数据移动
     * @param newData 返回的新数据
     * @param rowKeys 需要移动的行键值，一般为勾选的行键值
     * @param pos number 移动的位置 负数表示上移，正数表示下移，例如：-1 为上移一行、1 为下移一行
     * @param startIndex number 遍历开始的位置，向上移动则从0开始向下遍历，向下移动则行datalength - 1向上逐步遍历
     * @return {*} newData
     */
  const moveTreeData = useCallback((newData, rowKeys, pos) => {
    if (!pos || pos === 0 || !rowKeys.length) {
      return newData
    }
    let startIndex = pos < 0 ? 0 : newData.length - 1;
    if (pos < 0) { // 向上移动
      for (let index = startIndex; index < newData.length; index++) {
        const record = newData[index];
        const currentKey = getRowKey(record, index);
        if (rowKeys.includes(currentKey)) {
          let moveIndex = index + pos;
          // moveIndex = moveIndex <= startIndex ? startIndex : moveIndex >= innerData.length - startIndex ? innerData.length - startIndex : moveIndex; // 越界处理,移动多少距离
          moveIndex = moveIndex <= startIndex ? startIndex : moveIndex; // 越界处理,移动多少距离
          newData.splice(index, 1)
          newData.splice(moveIndex, 0, record)
          if (moveIndex === startIndex) {
            startIndex++;
            rowKeys = rowKeys.filter((key: Key) => key !== currentKey)
            moveTreeData(newData, rowKeys, pos);
            break;
          }
        }
        if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
          moveTreeData(record[childrenColumnName], rowKeys, pos)
        }
      }
    } else { // 向下移动
      for (let index = startIndex; index >= 0; index--) {
        const record = newData[index];
        const currentKey = getRowKey(record, index);
        if (rowKeys.includes(currentKey)) {
          let moveIndex = index + pos;
          moveIndex = moveIndex >= startIndex ? startIndex : moveIndex; // 越界处理,移动多少距离
          newData.splice(index, 1)
          newData.splice(moveIndex, 0, record)
          if (moveIndex === startIndex) {
            startIndex--;
            rowKeys = rowKeys.filter((key: Key) => key !== currentKey)
            moveTreeData(newData, rowKeys, pos);
            break;
          }
        }
        if (record[childrenColumnName] && Array.isArray(record[childrenColumnName]) && record[childrenColumnName].length) {
          moveTreeData(record[childrenColumnName], rowKeys, pos)
        }
      }
    }
    return newData;
  }, [innerData, getRowKey, childrenColumnName])

  /** ************移动行 end********************/

  /** ************行操作 start******************/

  // 增加编辑态的行类名
  const innerRowClassName = useCallback((record, index, indent) => {
    const currentKey = getRowKey(record, index);
    const cls = isEditKeys.includes(currentKey) ? [`wui-table-row-edit`] : []
    const cls2 = rowClassName && rowClassName(record, index, indent)
    cls.push(cls2)

    return cls.join(' ');
  }, [rowClassName, isEditKeys, getRowKey])

  // 表格的onRowHover事件
  const innerOnRowHover = useCallback((currentIndex, record, isHover, event) => {
    const currentKey = editRowRef.current && editRowRef.current[rowKey]
    if (currentKey && keyStatus[currentKey] && keyStatus[currentKey] === 'del') {
      editRowRef.current = null;
    }
    if (autoEditedByClickRows === 'hover') {
      const currentKey = getRowKey(record, currentIndex);
      if (isHover) { //  移入
        innerEditRowData({
          rowKey: currentKey,
          edit: true
        })
      } else { // 移出自动保存,如果移到按钮上
        if (!editRowRef.current) {
          return;
        }
        innerUpDateData({});
      }
    }
    onRowHover && onRowHover(currentIndex, record, isHover, event)
  }, [onRowHover, autoEditedByClickRows, getRowKey, innerData, isEditKeys, keyStatus, rowKey])

  /**
     * @description: 点击行开启编辑状态，一次只能编辑一行
     * @param {*} record：行数据
     * @param {*} index：行下标
     * @param {*} event：点击事件e
     * @return {*}
     */
  const onInnerRowClick = useCallback((record: DefaultRecordType, index: number, event: any) => {
    if (autoEditedByClickRows === 'click') {
      const currentKey = getRowKey(record, index);
      innerEditRowData({
        rowKey: currentKey,
        edit: true
      })
    }
    onRowClick && onRowClick(record, index, event)
  }, [autoEditedByClickRows, getRowKey, isEditKeys])

  // 确保返回的是最新值
  const innerOperationClick = useCallback((record, item, e, index) => {
    const newRecord = Object.keys(editRowRef.current || {}).length ? getRowKey(record) === getRowKey(editRowRef.current) ? { ...editRowRef.current } : { ...record } : { ...record }
    // let newRecord = {...(editRowRef.current || record)}
    e.stopPropagation();
    delete newRecord[INNER_ROW_KEY]
    if (item.key === "edit") {
      innerEditRowData({
        rowKey: newRecord[rowKey],
        edit: true
      })
    }
    operationClick && operationClick(newRecord, item, e, index)
  }, [innerData, operationClick, getRowKey, operationClick, currentEdit, rowKey])

  useEffect(() => {
    const editRow = document.querySelector(".wui-table-row-edit");

    const ro = new window.ResizeObserver(entries => {
      for (const entry of entries) {
        const cr = entry.contentRect;
        editRowHeight.current = cr.height;
        console.log('Element:', entry.target);
        console.log(`Element size: ${cr.width}px x ${cr.height}px`);
        console.log(`Element padding: ${cr.top}px ; ${cr.left}px`);
      }
    });
    editRow && ro.observe(editRow)
    return () => {
      // ro = null;
    }
  }, [editRowRef.current, document.querySelector(".wui-table-row-edit")])

  useEffect(() => {
    if (hoverRecord.current) {
      const isEdit = isEditKeys.includes(hoverRecord.current[rowKey]);
      setTimeout(() => {
        changeStyle(isEdit)
      }, 1)
    }
  }, [hoverRecord.current, isEditKeys, editRowRef.current, editRowHeight.current])

  function changeStyle (isEdit:boolean) {
    // const isEdit = isEdit

    const hoverContent = document.querySelector(".wui-table-hovercontent-hover");
    if (hoverContent) {
      const editHeight = editRowHeight.current;
      const viewHeight = tableCellHeight.current;
      const height = isEdit ? `${editHeight}px` : `${viewHeight}px`
      console.log(isEdit, height, tableCellHeight.current, "editRow.clientHeight111");

      hoverContent.style.lineHeight = height
      hoverContent.style.height = height
    }
  }
  // }, [editRowRef.current, isEditKeys, document.querySelector(".wui-table-row-edit")?.clientHeight])

  // 渲染操作按钮
  const getHoverContent = useCallback((record, index) => {
    const { maxCount = 3 } = operationTypeProps || {};
    const isEdit = isEditKeys.includes(getRowKey(record, index));
    const innerOperationItems = getOperationItems({
      operationType,
      isEdit,
      record,
      index,
      operationItems,
      saveText, cancelText, editText
    })
    if (!(innerOperationItems || []).length) {
      return null
    }

    const props = {
      operationItems: innerOperationItems,
      operationItemsMaxCount: maxCount,
      operationType,
      record,
      index,
      rowKey,
      operationClick: innerOperationClick,
      fieldid,
      foldStatus,
      setFoldStatus
    }
    // console.log(editRow?.clientHeight, isEdit, isEditKeys, tableCellHeight.current, e, "editRow.clientHeight");
    // changeStyle(isEdit);
    hoverRecord.current = record;
    return (typeof operationType === 'function' ? operationType(operationItems, record, index) : <Operations {...props} className={"as-editTable-operation-row"} style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }} />);
  }, [
    operationItems,
    operationTypeProps,
    operationType,
    rowKey,
    isEditKeys,
    autoEditedByClickRows,
    innerOnRowHover,
    innerData,
    innerOperationClick,
    foldStatus,
    editRowRef.current
  ])

  /** ************行操作 end********************/

  /** ************验证 start********************/

  /**
     * @description: 校验方法, 不做强拦截
     * @param range 校验范围 all | row | cell
     * @return {*}
     */
  const innerValidate = useCallback(options => {
    const { range = 'all', value, column, validateRecord, callback } = options
    let newCellErrors = { ...cellErrors };
    const leafColumns = getLeafColumns(innerColumns);
    if (range === 'all') {
      const rowKeys: any = [];
      newCellErrors = {};
      showData.forEach((record, i) => {
        const currentKey = getRowKey(record, i)
        const currentRealKey = record[rowKey];
        for (let index = 0; index < leafColumns.length; index++) {
          const column = leafColumns[index];
          const { required, pattern, dataIndex, patternMsg, validator, editAbled = true } = column;
          let isEditAbled = editAbled;
          if (typeof editAbled === 'function') {
            isEditAbled = editAbled(record, index, column);
          }
          const cellData = record[dataIndex];
          if (isEditAbled && validator && typeof validator === 'function') {
            validator(cellData, record, innerHandleData(innerData), (msg) => {
              if (msg) {
                newCellErrors[currentKey] = newCellErrors[currentKey] || {};
                newCellErrors[currentKey][dataIndex] = msg;
              }
            })
          }
          if (pattern) {
            const regexp = new RegExp(pattern);
            if (!regexp.test(cellData)) {
              newCellErrors[currentKey] = newCellErrors[currentKey] || {};
              newCellErrors[currentKey][dataIndex] = patternMsg;
            }
          }
          if (required) {
            if (cellData === null || cellData === '' || cellData === undefined) {
              newCellErrors[currentKey] = newCellErrors[currentKey] || {};
              newCellErrors[currentKey][dataIndex] = '此项必须填写';
              continue;
            }
          }
        }
        if (rowKeys.includes(currentRealKey)) {
          newCellErrors[currentKey] = newCellErrors[currentKey] || {};
          newCellErrors[currentKey][`${rowKey}`] = '数据每行的rowKey属性必须保持唯一！';
        }
        rowKeys.push(currentRealKey)
      })
    } else if (range === 'row') { // 整行验证
      const record = validateRecord || editRowRef.current;
      if (!record) {
        return;
      }
      const currentKey = getRowKey(record)
      newCellErrors = { ...cellErrors };
      if (newCellErrors[currentKey]) {
        delete newCellErrors[currentKey]
      }
      for (let index = 0; index < leafColumns.length; index++) {
        const column = leafColumns[index];
        const { required, pattern, dataIndex, patternMsg, validator } = column;
        const cellData = record[dataIndex];
        if (validator && typeof validator === 'function') {
          validator(cellData, record, innerHandleData(innerData), (msg) => { // TODO: 参数增加列信息, rowindex | column
            if (msg) {
              newCellErrors[currentKey] = newCellErrors[currentKey] || {};
              newCellErrors[currentKey][dataIndex] = msg;
            }
          })
        }
        if (pattern) {
          const regexp = new RegExp(pattern);
          if (!regexp.test(cellData)) {
            newCellErrors[currentKey] = newCellErrors[currentKey] || {};
            newCellErrors[currentKey][dataIndex] = patternMsg;
          }
        }
        if (required) {
          if (cellData === null || cellData === '' || cellData === undefined) {
            newCellErrors[currentKey] = newCellErrors[currentKey] || {};
            newCellErrors[currentKey][dataIndex] = '此项必须填写';
            continue;
          }
        }
        if (currentKey !== record[rowKey]) { // 改变了rowKey
          const resetkeys = getDataKeys(innerData).filter(key => key !== currentKey);
          if (resetkeys.includes(record[rowKey])) {
            newCellErrors[currentKey] = newCellErrors[currentKey] || {};
            newCellErrors[currentKey][rowKey] = '数据每行的rowKey属性必须保持唯一！';
          }
        }
      }
    } else if (range === 'cell') { // 单元格验证
      if (!validateRecord) {
        return;
      }
      const currentKey = getRowKey(validateRecord)
      newCellErrors = { ...cellErrors };
      const { required, pattern, validator, dataIndex, patternMsg } = column || {}
      if (newCellErrors[currentKey] && newCellErrors[currentKey][dataIndex]) {
        delete newCellErrors[currentKey][dataIndex];
      }
      if (validator && typeof validator === 'function') {
        validator(value, validateRecord, innerData, (msg) => {
          if (msg) {
            newCellErrors[currentKey] = newCellErrors[currentKey] || {};
            newCellErrors[currentKey][dataIndex] = msg;
          }
        })
      }
      if (pattern) {
        const regexp = new RegExp(pattern);
        if (!regexp.test(value)) {
          newCellErrors[currentKey] = newCellErrors[currentKey] || {};
          newCellErrors[currentKey][dataIndex] = patternMsg;
        }
      }
      if (required) {
        if (value === null || value === '' || value === undefined) {
          newCellErrors[currentKey] = newCellErrors[currentKey] || {};
          newCellErrors[currentKey][dataIndex] = '此项必须填写';
        }
      }
      if (currentKey !== validateRecord[rowKey]) { // 改变了rowKey
        const resetkeys = getDataKeys(innerData).filter(key => key !== currentKey);
        if (resetkeys.includes(validateRecord[rowKey])) {
          newCellErrors[currentKey] = newCellErrors[currentKey] || {};
          newCellErrors[currentKey][rowKey] = '数据每行的rowKey属性必须保持唯一！';
        }
      }
    }
    callback && callback(newCellErrors)
    setCellErrors(newCellErrors)
  }, [innerColumns, showData, getRowKey, cellErrors, rowKey])

  // 增加或者更新单元格的error信息
  const innerUpdateCellError = useCallback((options) => {
    const { rowKey, dataIndex, errorMsg } = options;
    const innerCellErrors = { ...cellErrors };
    innerCellErrors[rowKey] = innerCellErrors[rowKey] || {};
    innerCellErrors[rowKey][dataIndex] = errorMsg;
    setCellErrors(innerCellErrors);
  }, [cellErrors])

  // 清除某个单元格的错误信息
  const innerClearCellError = useCallback((options) => {
    const { rowKey, dataIndex } = options;
    const innerCellErrors = { ...cellErrors }
    if (innerCellErrors && innerCellErrors[rowKey] && innerCellErrors[rowKey][dataIndex]) {
      delete innerCellErrors[rowKey][dataIndex];
      setCellErrors({ ...innerCellErrors });
    }
  }, [cellErrors])

  // 获取某个单元格的错误信息
  const innerGetCellError = useCallback((options) => {
    const { rowKey, dataIndex } = options;
    const innerCellErrors = { ...cellErrors }
    innerCellErrors[rowKey] = innerCellErrors[rowKey] || {};
    return innerCellErrors[rowKey][dataIndex];
  }, [cellErrors])

  // 清除某一行的所有单元格错误信息
  const innerClearRowError = useCallback((options) => {
    const { rowKey } = options;
    const innerCellErrors = { ...cellErrors }
    if (innerCellErrors && innerCellErrors[rowKey]) {
      delete innerCellErrors[rowKey];
      setCellErrors({ ...innerCellErrors });
    }
  }, [cellErrors])

  /** ************验证 end**********************/

  /** ************右键 start********************/

  // 右键自定义渲染内容
  const innerPopMenu = useMemo(() => {
    if (popMenu && popMenu !== 'default') return popMenu;
    const defaultPopMenu = (key, dataIndex) => [
      { key: 'addBefore', text: '向上新增一行' }, // n
      { key: 'addAfter', text: '向下新增一行' }, // n
      { key: 'moveUp', text: '上移一行' },
      { key: 'moveDown', text: '下移一行' }
    ]
    return popMenu === 'default' ? defaultPopMenu : null;
  }, [popMenu])

  const onInnerPopMenuClick = useCallback((value: {type: string, key: string, dataIndex: string}) => {
    const { type, key } = value;
    let allData = innerData;
    let isEditKeys = null;
    switch (type) {
    case 'addBefore':
      innerAddRow({ pos: 'before', posRowKey: key, callback: (data, key) => {
        isEditKeys = key;
        allData = data;
      } })
      break;
    case 'addAfter':
      innerAddRow({ pos: 'after', posRowKey: key, callback: (data, key) => {
        isEditKeys = key;
        allData = data;
      } })
      break;
    case 'moveUp':
      innerRowMoveTo({ rowKey: key, pos: -1 })
      break;
    case 'moveDown':
      innerRowMoveTo({ rowKey: key, pos: 1 })
      break;
    default:
      break;
    }
    onPopMenuClick && onPopMenuClick(value, allData, isEditKeys);
  }, [innerData, isEditKeys])

  /** ************右键 end**********************/

  // const innerOnBodyMouseLeave = useCallback(() => {
  //     isEditRef.current = [];
  //     setIsEditKeys([])
  //     onBodyMouseLeave && onBodyMouseLeave()
  // }, [onBodyMouseLeave])

  // 暴露的方法
  useImperativeHandle(ref, () => ({
    // 在第一行新增数据
    addRow: (options: {rowData: DefaultRecordType[], callback: any}) => {
      const { rowData, callback } = options || {}
      innerAddRow({ pos: 'first', rowData, callback })
    },
    // 在末行新增数据
    addRowLast: (options: {rowData: DefaultRecordType[], callback: any}) => {
      const { rowData, callback } = options || {}
      innerAddRow({ pos: 'last', rowData, callback })
    },
    // 增加子级
    addRowChild: (options: {posRowKey: Key, rowData: DefaultRecordType[], callback: any}) => {
      const { posRowKey, rowData, callback } = options || {}
      innerAddRow({ pos: 'child', posRowKey, rowData, callback })
    },
    // 某一条数据前插入
    addRowBefore: (options: { posRowKey: Key, rowData: DefaultRecordType[], callback: any; }) => {
      const { posRowKey, rowData, callback } = options || {};
      innerAddRow({ pos: 'before', posRowKey, rowData, callback });
    },
    // 某一条数据后插入
    addRowAfter: (options: { posRowKey: Key, rowData: DefaultRecordType[], callback: any; }) => {
      const { posRowKey, rowData, callback } = options || {};
      innerAddRow({ pos: 'after', posRowKey, rowData, callback });
    },
    // 获取正在编辑的key
    getIsEditKey: () => {
      return isEditRef.current || []
    },
    // 清除所有行的编辑状态åå
    clearEditAll: (options: {callback: any}) => {
      const { callback } = options;
      isEditRef.current = [];
      callback && callback()
    },
    // 清除所有数据
    clearAllData: (options: {callback: any}) => {
      const { callback } = options;
      setInnerData([]);
      callback && callback()
    },
    // 将指定行设置为编辑态或查看态
    editRow: (options: { rowKey: Key, edit: boolean, callback: any}) => { // 启用或者关闭编辑态 editRow(rowKey, isEdit, callback)
      innerEditRowData(options);
    },

    // 更新整个行数据 (upDate)
    saveRowData: (options: {rowData: DefaultRecordType, callback: any}) => {
      const { rowData, callback } = options;
      saveInnerMultiCellData({
        rowData,
        callback,
        range: 'row'
      })
    },

    // 取消保存
    cancel: (options: { rowKey: Key }) => {
      const { rowKey } = options;
      innerCancel(rowKey);
    },
    // 删除指定行(支持单个删除和多个删除)
    deleteData: (options: {rowKey: Key | Key[], callback: any}) => {
      innerDelData(options)
    },
    // 获取全部数据
    getAllData: () => {
      return innerHandleData(innerData);
    },

    // 获取新增的数据keys
    getAddRowKeys: () => {
      const { innerAddKeys } = getKeyStatus()
      return innerAddKeys;
    },

    // 获取新增的数据
    getAddRows: () => {
      return innerAddRows();
    },

    // 获取当前选中行的key
    getSelectedRowKeys: () => {
      return innerSelectedRowKeys
    },

    // 设置选中行的key
    setSelectedRowKeys: (options: { rowKey: Key | Key[]}) => {
      const { rowKey } = options;
      const rowKeys = Array.isArray(rowKey) ? rowKey : [rowKey]
      setInnerSelectedRowKeys(rowKeys)
      selectedRowRef.current = rowKeys;
    },
    // 获取当前选中行的数据
    getSelectedRows: () => {
      return innerHandleData(getKeyData(innerSelectedRowKeys))
    },

    // 清空全选
    clearSelectedRowKeys: () => {
      setInnerSelectedRowKeys([])
      selectedRowRef.current = [];
    },

    // 获取已编辑过的行Key
    getEditRowKeys: () => {
      const { innerEditKeys } = getKeyStatus()
      return innerEditKeys;
    },

    // 获取已编辑过的数据
    getEditRows: () => {
      return innerEditRows();
    },

    // 获取已删除的数据的keys
    getDeleteRowKeys: () => {
      const { innerDelKeys } = getKeyStatus()
      return innerDelKeys;
    },

    // 获取已删除的数据
    getDeleteRows: () => {
      return innerDelRows()
    },

    // 通过行键值获取指定行数据, 支持string | array
    getRowDataByKey: (options: { key: Key | Key[]}) => {
      const { key } = options;
      const keys = Array.isArray(key) ? key : [key];
      const getData = getKeyData(keys);
      return getData
    },

    /**
         * @description: 获取指定单元格数据
         * @param {*} rowKey : 单元格行对应的键
         * @param {*} dataIndex：单元格对应列的dataIndex
         * @return {*}
         */
    getCellDataByKey: (options: {rowKey: Key, dataIndex: Key}) => {
      const { rowKey, dataIndex } = options || {};
      const rowData = getKeyData([rowKey])[0];
      return rowData[dataIndex]
    },

    /**
         * 更新指定列下的单元格值
         * @param dataIndex 列数据索引名
         * @param cellValue 单元格更新后的值
         * @param callback 更新后的回调
         */
    saveColumnData: (options: {dataIndex: Key, cellValue: any, callback: any}) => {
      const { dataIndex, cellValue, callback } = options;
      innerSaveColumnData({ dataIndex, cellValue, fillType: 'all', callback });
    },
    /**
         * 从指定行开始向上更新指定列下的单元格值
         * @param rowKey 当更新方式为 up|down 时，必须指定此参数值
         * @param dataIndex 列数据索引名
         * @param cellValue 单元格更新后的值
         * @param upNum 向上填充的行数
         * @param callback 更新后的回调
         */
    saveColumnDataFillUp: (options: {rowKey: Key, dataIndex: Key, cellValue: any, fillNum: number, callback: any}) => {
      const { rowKey, dataIndex, cellValue, fillNum, callback } = options;
      innerSaveColumnData({ rowKey, dataIndex, cellValue, fillType: 'up', fillNum, callback });
    },
    /**
         * 从指定行开始向下更新指定列下的单元格值
         * @param rowKey 当更新方式为 up|down 时，必须指定此参数值
         * @param dataIndex 列数据索引名
         * @param cellValue 单元格更新后的值
         * @param fillNum 向下填充的行数
         * @param callback 更新后的回调
         */
    saveColumnDataFillDown: (options: {rowKey: Key, dataIndex: Key, cellValue: any, fillNum: number, callback: any}) => {
      const { rowKey, dataIndex, cellValue, fillNum, callback } = options;
      innerSaveColumnData({ rowKey, dataIndex, cellValue, fillType: 'down', fillNum, callback });
    },
    /**
         * 更新指定行键值对应的多个单元格的数据（即：更行数据）
         * @param rowKey 行键值
         * @param rowData 列数据
         * @param callback 更新后的回调
         */
    saveMultiCellData: (options: {rowData: DefaultRecordType, callback: any}) => { // 特定单元格更新
      const { rowData, callback } = options;
      saveInnerMultiCellData({
        rowData,
        callback,
        range: 'cell'
      })
    },
    /**
         *获取所有单元格的错误消息
        * 格式如下：
        *  {
        *     '行键值1':{
        *          'A字段键值':'A错误描述',
        *          'B字段键值':'B错误描述',
        *          ...
        *     },
        *     '行键值2':{
        *          'A字段键值':'A错误描述',
        *          'B字段键值':'B错误描述',
        *          ...
        *     },
        *     ...
        *  }
        */
    getAllCellError: () => {
      return cellErrors;
    },
    /**
         * 设置所有单元格的错误消息，cellErrors错误消息对象集合格式必须是通过addCellError方法构建的错误消息内容格式。
         * 内容格式参看getAllCellError()方法返回的格式。
         */
    setAllCellError: (options: {cellErrors: any, callback: any}) => {
      const { cellErrors, callback } = options;
      setCellErrors(cellErrors);
      callback && callback()
    },
    /**
        *  给cellErrors对象集合里面添加一个新的单元格错误消息，不会立即刷新，需要手动刷新或调用setAllCellError方法进行刷新。
        *  cellErrors 错误消息集合对象，可以是getAllCellError()获取的对象或者空对象{}
        *  options={
        *    rowKey string 行键值
        *    dataIndex string 列定义键值
        *    errorMsg string 描述错误
        *  }
        * return 添加后的错误消息集合对象，内容格式参看getAllCellError()方法返回的格式。
        */
    updateCellError: (options: {rowKey: Key, dataIndex: Key, errorMsg: any}) => {
      innerUpdateCellError(options)
    },
    /**
        * 清除指定单元格的错误消息
        * options={
        *  rowKey string 行键值
        *  dataIndex string 列定义键值
        * }
        */
    clearCellError: (options: {rowKey: Key, dataIndex: Key}) => {
      innerClearCellError(options)
    },

    /**
        * 获取指定单元格的错误消息
        * options={
        *  rowId string 行键值
        *  dataIndex string 列定义键值
        * }
        */
    getCellError: (options: {rowKey: Key, dataIndex: Key}) => {
      innerGetCellError(options)
    },
    /**
         * 将指定行进行移动
         * 参数options列表
         * @param rowKey string|array 需要移动的行键值，一般为勾选的行键值
         * @param pos number 移动的位置 负数表示上移，正数表示下移，例如：-1 为上移一行、1 为下移一行
         * @param clearSelected boolean 移动后是否清除勾选状态
         * @param callback 移动完成后的回调
         */
    rowMoveTo: (options: any) => {
      // const {rowKey, pos, clearSelected, callback} = options
      innerRowMoveTo(options)
    },
    /**
         * 校验表格数据
         * 参数options列表
         * @param rowKey string|array 需要移动的行键值，一般为勾选的行键值
         * @param pos number 移动的位置 负数表示上移，正数表示下移，例如：-1 为上移一行、1 为下移一行
         * @param clearSelected boolean 移动后是否清除勾选状态
         * @param callback 移动完成后的回调
         */
    validate: (options) => {
      innerValidate(options);
    }
  }))

  const onSaveRecord = useCallback((data, record, index, e) => {
    console.log(data, "save")

    editRowRef.current = { ...data };
    innerOperationClick(record, { key: "save", text: saveText }, e, index)
  })

  const onRecordCancel = (record, index, e) => {
    // innerCancel(record[rowKey]);
    innerOperationClick(record, { key: "cancel", text: cancelText }, e, index)
  }
  const onValuesChange = useCallback((record, dataIndex, changedValues, allValues) => {
    const col = Object.keys(changedValues)[0];
    const column = columns.filter(item => item.dataIndex === col)[0];

    cellChange({
      value: changedValues[col],
      record,
      onCellChange: column?.onCellChange,
      col: column
    })
  })
  // 待优化： 同样的columns不应该重新生成表单
  const FormWrapper = useCallback((record, dataIndex) => {
    return <FormContent {...(formProps || {})} onSaveRecord={onSaveRecord} tableRowKey={rowKey} onValuesChange={onValuesChange.bind(null, record, dataIndex)} onCancel={onRecordCancel} index={dataIndex} columns={columns} record={record} data={innerData} validateTrigger={props.validateTrigger} />
  }, [columns, editRowRef.current, isEditKeys, rowKey, innerData, formProps])

  // 内部将表单内容放在展开行中，和外部展开逻辑做兼容处理。
  const expandableProps = {
    expandRowByClick: false,
    ...(props.expandable || {}),
    expandedRowKeys: Array.from(new Set([...(props.expandable?.expandedRowKeys || [])]))

  }
  if (tableType === "inlineForm") {
    Object.assign(expandableProps, {
      expandedRowKeys: Array.from(new Set([...isEditKeys, ...(props.expandable?.expandedRowKeys || [])])),
      showExpandIcon: (record, index) => {
      // 如果是树结构，有children则遵循用户自定义。
        const { showExpandIcon } = props?.expandable || {};
        const defaultShow = isFunc(showExpandIcon) ? showExpandIcon(record, index) : showExpandIcon;
        console.log(record.children, "record.children")
        if (record.children) {
          return true
        }
        // 如果不是树，则关闭icon
        return defaultShow
      },
      expandedRowRender: (record, index) => {
        const { expandedRowRender } = props?.expandable || {};
        const WrapperDom = expandedRowRender ? expandedRowRender(record, index) : null;
        if (WrapperDom) {
          return <div>
            {FormWrapper(record, index)}
            {WrapperDom}
          </div>
        }
        const isEdit = (isEditRef.current || isEditKeys).includes(record[rowKey]);

        return isEdit ? <>{FormWrapper(record, index)}</> : ""
      }
    })
  }

  const innerMergeColumns = useMemo(() => {
    const operationColumn = [{
      title: "",
      dataIndex: "operation",
      fixed: "right",
      width: 72,
      className: "as-tableOperation",
      render: (text, record, index) => {
        return getHoverContent(record, index);
      }
    }]
    if (foldStatus) {
      return [...innerColumns, ...operationColumn]
    } else {
      return [...innerColumns]
    }
  }, [innerColumns, foldStatus])

  const onDropBorder = (e, width, column, columns) => {
    innerMergeColumns.forEach(item => {
      if (item.dataIndex === column.dataIndex) {
        tableColumnsMap.current[item.dataIndex] = { width }
      }
    })
    props.onDropBorder && props.onDropBorder(e, width, column, columns)
  }

  return (
    <MergeTable
      {...props}
      className={className ? `${className} ${prefix}-table-edit-pro` : `${prefix}-table-edit-pro`}
      data={showData}
      bodyClassName={ `${props.bodyClassName ? props.bodyClassName : ""} ${innerShowRowNum && expandableProps.expandedRowKeys.length ? `${prefix}-table-edit-pro-index-indent` : ""}`}
      columns={innerMergeColumns}
      showRowNum={innerShowRowNum}
      rowSelection={rowSelection ? mergeRowSelection : undefined}
      onRowClick={onInnerRowClick}
      onPopMenuClick={onInnerPopMenuClick}
      popMenu={innerPopMenu}
      onRowHover={innerOnRowHover}
      hoverContent={foldStatus ? null : getHoverContent}
      autoCheckedByClickRows={autoCheckedByClickRows}
      isBigData={isBigData}
      isSingleFind={isSingleFind}
      isSum={isSum}
      onDropBorder={onDropBorder}
      dragborder={!!isDragColumn}
      isDragColumn={isDragColumn}
      isFilterColumn={isFilterColumn}
      isSort={isSort}
      sortEnable={!!isSort}
      isSingleFilter={isSingleFilter}
      rowClassName={innerRowClassName}
      onDropRow={innerOnDropRow}
      expandable={expandableProps}
      ref={editRef}
    />
  )
})

EditTable.defaultProps = {
  type: "inlineForm",
  cancelText: "取消",
  saveText: "保存",
  editText: "编辑"
}
EditTable.displayName = "EditTable"

export default EditTable
